import { render } from "./InputSearchMinimal.vue?vue&type=template&id=4bbc004a&scoped=true"
import script from "./InputSearchMinimal.vue?vue&type=script&lang=js"
export * from "./InputSearchMinimal.vue?vue&type=script&lang=js"

import "./InputSearchMinimal.vue?vue&type=style&index=0&id=4bbc004a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbc004a"]])

export default __exports__